import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
    methods: {
        async generatePdf() {
            try {
                this.isDisableDownloadReportBtn = true;

                let pdf = new jsPDF(this.pdfOption);

                const pdf_width = pdf.internal.pageSize.width;
                const pdf_height = pdf.internal.pageSize.height;

                const margin_l = this.pdfConfig.margin.l;
                const margin_t = this.pdfConfig.margin.t;
                const margin_b = this.pdfConfig.margin.b;

                let cellHeight = 20;

                const addNewPageIfNeeded = (incrementValue) => {
                    if ((pdf_position_y + incrementValue) >= pdf_height - margin_t) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset the position to the top of the new page
                    } else {
                        pdf_position_y += incrementValue; // Add the input value
                    }
                };

                let pdf_position_y = 0;
                pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
                pdf.addFileToVFS("Sarabun-Regular.ttf", font);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

                pdf.setFont("Sarabun", "bold");
                pdf.setFontSize(this.pdfConfig.typo.header);
                pdf_position_y += margin_t;

                this.thaitext(
                    pdf,
                    "รายงานข้อมูลนักเรียน",
                    pdf_width / 2,
                    pdf_position_y,
                    0,
                    "center"
                );
                addNewPageIfNeeded(this.pdfConfig.endLegend);

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                this.thaitext(
                    pdf,
                    "วันที่พิมพ์ : " + ' ' + this.formatDateToThai(this.moment().format("YYYY-MM-DD"), false),
                    pdf_width - 40,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ผู้พิมพ์ข้อมูล : " + ' ' + (this.currentProfile ? this.currentProfile.fullName : '-'),
                    pdf_width - 20,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                let hasEnrollDate = this.enrollDate?.start ? true : false;
                let startDate = "";
                let endDate = "";
                if (hasEnrollDate) {
                    startDate = this.moment(this.enrollDate.start).format("YYYY-MM-DD");
                    endDate = this.moment(this.enrollDate.end).format("YYYY-MM-DD");
                }
                this.thaitext(
                    pdf,
                    "ช่วงวันที่ลงทะเบียน : " + (hasEnrollDate ? this.formatDateToThai(startDate, false) + ' - ' + this.formatDateToThai(endDate, false) : '-'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "สถาบัน : " + this.instituteName,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "สถานะ : " + this.selectedStatusText,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "รวมนักเรียนทั้งหมด : " + this.studentInfoReportList.length + " คน",
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                const tableHeader = ["ลำดับ", "รหัสนักเรียน", "ชื่อนักเรียน", "วันที่ลงทะเบียน", "โรงเรียน", "เบอร์โทรศัพท์", "E-Mail", "บัตรประชาชน", "วันเดือนปีเกิด"];
                let colWidths = [30, 60, 100, 60, 80, 55, 80, 65, 60];
                let headerX = 20;
                pdf.setLineWidth(0.1);

                const fontSize = pdf.getFontSize();
                const fontHeight = fontSize * 0.3528;
                const lineSpacing = 8; // Extra padding between multiline texts

                const renderTableHeader = () => {
                    pdf.setFont("Sarabun", "bold");

                    for (let i = 0; i < tableHeader.length; i++) {
                        const width = colWidths[i];

                        // 1. Draw Header Cell Border
                        pdf.rect(headerX, pdf_position_y, width, cellHeight);

                        // 2. Split text by newline for multiline support
                        const lines = tableHeader[i].split('\n');
                        const totalLines = lines.length;

                        // Calculate the starting Y position so the entire block of text is vertically centered
                        const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                        let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                        // 3. Loop through and center each individual line
                        for (let j = 0; j < totalLines; j++) {
                            const lineText = lines[j];

                            // Calculate horizontal center for the current line
                            const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                            const textX = headerX + (width - textWidth) / 2;

                            // Render the text using your custom Thai text function
                            this.thaitext(pdf, lineText, textX, startY);

                            // Move Y down for the next line
                            startY += fontHeight + lineSpacing;
                        }

                        headerX += width;
                    }
                    pdf_position_y += cellHeight;

                    pdf.setFont("Sarabun", "normal");
                }

                // Create table header
                renderTableHeader();

                const maxPrintableY = pdf_height - margin_b;

                if (this.studentInfoReportList.length > 0) {
                    this.studentInfoReportList.forEach((row, index) => {
                        let columnX = margin_l;
                        const studentId = row.studentId ? row.studentId.toString() : '-';
                        const enrollDate = this.thaiDateFilter(row.registerDate);
                        const studentName = row.firstName && row.lastName ? `${row.firstName} ${row.lastName}` : '-';
                        const phone = row.phone ? row.phone.toString() : '-';
                        const idCard = row.idCard ? row.idCard.toString() : '-';
                        const dateOfBirth = this.thaiDateFilter(row.dateOfBirth);

                        // 1. Split long text into arrays of wrapped lines
                        const padding = 10;
                        const studentIdLines = pdf.splitTextToSize(studentId, colWidths[1] - padding);
                        const studentNameLines = pdf.splitTextToSize(studentName, colWidths[2] - padding);
                        const schoolNameLines = pdf.splitTextToSize(row.school || '-', colWidths[4] - padding);
                        const emailLines = pdf.splitTextToSize(row.email || '-', colWidths[6] - padding);

                        // 2. Calculate heights for individual text blocks
                        const fontHeight = pdf.getFontSize() * 0.3528;
                        const lineSpacing = 8;
                        const calculatedStudentIdHeight = (studentIdLines.length * fontHeight) + ((studentIdLines.length - 1) * lineSpacing) + 10;
                        const calculatedStudentNameHeight = (studentNameLines.length * fontHeight) + ((studentNameLines.length - 1) * lineSpacing) + 10;
                        const calculatedSchoolNameHeight = (schoolNameLines.length * fontHeight) + ((schoolNameLines.length - 1) * lineSpacing) + 10;
                        const calculatedEmailHeight = (emailLines.length * fontHeight) + ((emailLines.length - 1) * lineSpacing) + 10;

                        // 3. Find the maximum height for the entire row
                        let finalRowHeight = Math.max(cellHeight, calculatedStudentIdHeight, calculatedStudentNameHeight, calculatedSchoolNameHeight, calculatedEmailHeight);

                        // ==========================================
                        // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                        // ==========================================
                        if (pdf_position_y + finalRowHeight > maxPrintableY) {
                            pdf.addPage();
                            pdf_position_y = margin_t; // Reset to the top of the new page

                            // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                            headerX = 20;
                            renderTableHeader();
                        }

                        // ==========================================

                        // --- DRAW COLUMN 1: No. ---
                        pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                        const idxText = (index + 1).toString();
                        const idxWidth = pdf.getStringUnitWidth(idxText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                        this.thaitext(pdf, idxText, columnX + (colWidths[0] - idxWidth) / 2, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[0];

                        // --- DRAW COLUMN 2: Student ID ---
                        pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                        const totalStudentIdHeight = (studentIdLines.length * fontHeight) + ((studentIdLines.length - 1) * lineSpacing);
                        let studentIdY = pdf_position_y + (finalRowHeight - totalStudentIdHeight) / 2 + fontHeight;
                        studentIdLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, studentIdY);
                            studentIdY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[1];

                        // --- DRAW COLUMN 3: Student Name ---
                        pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                        const totalStudentNameHeight = (studentNameLines.length * fontHeight) + ((studentNameLines.length - 1) * lineSpacing);
                        let studentNameY = pdf_position_y + (finalRowHeight - totalStudentNameHeight) / 2 + fontHeight;
                        studentNameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, studentNameY);
                            studentNameY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[2];

                        // --- DRAW COLUMN 4: Enroll Date ---
                        pdf.rect(columnX, pdf_position_y, colWidths[3], finalRowHeight);
                        this.thaitext(pdf, enrollDate, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[3];

                        // --- DRAW COLUMN 5: School ---
                        pdf.rect(columnX, pdf_position_y, colWidths[4], finalRowHeight);
                        const totalSchoolHeight = (schoolNameLines.length * fontHeight) + ((schoolNameLines.length - 1) * lineSpacing);
                        let schoolY = pdf_position_y + (finalRowHeight - totalSchoolHeight) / 2 + fontHeight;
                        schoolNameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, schoolY);
                            schoolY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[4];

                        // --- DRAW COLUMN 6: Phone ---
                        pdf.rect(columnX, pdf_position_y, colWidths[5], finalRowHeight);
                        this.thaitext(pdf, phone, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[5];

                        // --- DRAW COLUMN 7: E-Mail ---
                        pdf.rect(columnX, pdf_position_y, colWidths[6], finalRowHeight);
                        const totalEmailHeight = (emailLines.length * fontHeight) + ((emailLines.length - 1) * lineSpacing);
                        let emailY = pdf_position_y + (finalRowHeight - totalEmailHeight) / 2 + fontHeight;
                        emailLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, emailY);
                            emailY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[6];

                        // --- DRAW COLUMN 8: Id Card ---
                        pdf.rect(columnX, pdf_position_y, colWidths[7], finalRowHeight);
                        this.thaitext(pdf, idCard, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[7];

                        // --- DRAW COLUMN 9: Date Of Birth ---
                        pdf.rect(columnX, pdf_position_y, colWidths[8], finalRowHeight);
                        this.thaitext(pdf, dateOfBirth, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[8];

                        // 4. Move Y down cleanly by the shared unified row height
                        pdf_position_y += finalRowHeight;
                    });
                } else {
                    let currentX = margin_l;
                    cellHeight = 25;

                    // Combine widths of Column for the text "รวมทั้งหมด"
                    const spanWidth = colWidths.reduce(
                        (accumulator, currentValue) => accumulator + currentValue,
                        0,
                    );

                    pdf.setFillColor(240, 240, 240);
                    pdf.rect(currentX, pdf_position_y, spanWidth, cellHeight, 'F');
                    pdf.rect(currentX, pdf_position_y, spanWidth, cellHeight, 'S');

                    const labelText = 'ไม่มีข้อมูล';
                    const totalWidth = pdf.getStringUnitWidth(labelText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    // Center align the total number in the last column
                    const totalX = currentX + (spanWidth - totalWidth) / 2;
                    const labelY = pdf_position_y + (cellHeight - fontHeight) / 2 + fontHeight;

                    this.thaitext(pdf, labelText, totalX, labelY);
                }

                // =========================================================================
                // DRAW PAGE NUMBERS (ALWAYS PLACE AT THE VERY END OF YOUR SCRIPT)
                // =========================================================================

                const totalPages = pdf.internal.getNumberOfPages();

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);

                    // Render top-right page counter
                    this.thaitext(
                        pdf,
                        `${i} / ${totalPages}`,
                        pdf_width - 20,
                        20,
                        0,
                        "right"
                    );
                }

                setTimeout(() => {
                    pdf.save("รายงานข้อมูลนักเรียน.pdf");
                }, 0);
                this.isDisableDownloadReportBtn = false;
            } catch (error) {
                console.log(error)
            }
        }
    }
}